/**
 * Initialize translation field toggle functionality
 * Checkboxes with data-translation-toggle attribute will toggle visibility
 * of the element with the ID specified in the attribute value
 */
export function initTranslationFieldToggle() {
  document.querySelectorAll('[data-translation-toggle]').forEach((checkbox) => {
    const targetId = checkbox.dataset.translationToggle
    const fields = document.getElementById(targetId)
    if (!fields) return

    checkbox.addEventListener('change', function () {
      if (this.checked) {
        fields.classList.remove('d-none')
        fields.querySelectorAll('input, textarea').forEach(input => input.disabled = false)
      } else {
        fields.classList.add('d-none')
        fields.querySelectorAll('input, textarea').forEach(input => input.disabled = true)
      }
    })
  })
}
